export default "__VITE_ASSET__DoVFFJSd__"